import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs';
import { AppConfigService } from './providers/config.service';
import { DataLoaderService } from './services/data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class AssetTagService {
  private http = inject(HttpClient);
  private config = inject(AppConfigService);
  private loader = inject(DataLoaderService);

  public add(assetId: string, tagId: string) {
    return this.http.post(`${this.config.apiEndpoint}/assets/${assetId}/tags/${tagId}`, {}).pipe(
      tap(tag => {
        this.loader.removeFuzzy('assets');
        return tag;
      })
    );
  }

  public remove(assetId: string, tagId: string) {
    return this.http.delete(`${this.config.apiEndpoint}/assets/${assetId}/tags/${tagId}`).pipe(
      tap(() => {
        this.loader.removeFuzzy('assets');
      })
    );
  }
}
